// The onboarding road map. Kept beside the page so each step can be filled in
// without touching the rail.
export const STEPS = [
  { id: "profile", title: "Company Profile", subtitle: "Who you are" },
  { id: "trade", title: "Your Trade", subtitle: "Pick your industry preset" },
  { id: "vocab", title: "Your Language", subtitle: "We speak your dialect" },
  { id: "work", title: "Work Setup", subtitle: "Work types & branches" },
  { id: "team", title: "Team & Roles", subtitle: "The roles you'll use" },
  { id: "data", title: "Your Data", subtitle: "Customers, vendors, roster" },
  { id: "review", title: "Review & Submit", subtitle: "Your Makani blueprint" },
];

// Only completed steps are clickable — a later step may depend on answers that
// haven't been given yet.
export function StepRail({ current, onJump }) {
  return (
    <div className="w-[250px] shrink-0">
      {STEPS.map((step, i) => {
        const isCurrent = i === current;
        const isDone = i < current;
        return (
          <div
            key={step.id}
            onClick={() => onJump(i)}
            className={`flex items-start gap-3 px-3 py-[10px] rounded-[10px] mb-[2px] ${
              isCurrent ? "bg-blueColor/10" : ""
            } ${isDone ? "cursor-pointer" : ""}`}
          >
            <div
              className={`w-[26px] h-[26px] rounded-full border-[2px] flex items-center justify-center shrink-0 text-[12px] font-OpenSansSemiBold ${
                isDone
                  ? "bg-green-600 border-green-600 text-white"
                  : isCurrent
                    ? "border-blueColor text-blueColor bg-white"
                    : "border-borderColor text-subTitleColor bg-white"
              }`}
            >
              {isDone ? "✓" : i + 1}
            </div>
            <div>
              <p className="text-[14px] font-OpenSansSemiBold text-titleColor">{step.title}</p>
              <p className="text-[11.5px] font-OpenSansRegular text-subTitleColor mt-[2px]">{step.subtitle}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
